import React from 'react';
import { Rocket, CreditCard, Trophy, Heart, ShoppingCart, Building, ArrowRight } from 'lucide-react';
import { industries } from '../../data/mock';

const iconMap = {
  Rocket: Rocket,
  CreditCard: CreditCard,
  Trophy: Trophy,
  Heart: Heart,
  ShoppingCart: ShoppingCart,
  Building: Building
};

export const IndustriesSection = () => {
  return (
    <section id="industries" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#f26522] font-semibold text-sm tracking-wider uppercase">
            Industries
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-[#1e3a5f] leading-tight">
            Expertise Across Diverse Sectors
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            We understand the unique challenges and opportunities in each industry we serve.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, i) => {
            const Icon = iconMap[industry.icon] || Building;
            return (
              <div
                key={i}
                className="group p-6 bg-white rounded-2xl border border-gray-100 hover:border-[#f26522]/30 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-xl bg-[#1e3a5f]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#f26522] transition-colors duration-300">
                    <Icon className="w-7 h-7 text-[#1e3a5f] group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#1e3a5f] mb-2 group-hover:text-[#f26522] transition-colors">
                      {industry.name}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {industry.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center px-6 py-3 bg-[#f26522] text-white font-medium rounded-lg hover:bg-[#d95a1b] transition-colors"
          >
            Discuss Industry Requirements
            <ArrowRight className="ml-2 w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
